import { render, staticRenderFns } from "./VueDjGantt.vue?vue&type=template&id=bbf81028"
import script from "./VueDjGantt.vue?vue&type=script&lang=js"
export * from "./VueDjGantt.vue?vue&type=script&lang=js"
import style0 from "./VueDjGantt.vue?vue&type=style&index=0&id=bbf81028&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf81028')) {
      api.createRecord('bbf81028', component.options)
    } else {
      api.reload('bbf81028', component.options)
    }
    module.hot.accept("./VueDjGantt.vue?vue&type=template&id=bbf81028", function () {
      api.rerender('bbf81028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VueDjGantt.vue"
export default component.exports